import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    // eslint-disable-next-line max-params
    createFetchParams: (selectedMonth, pagination, search, sort, exclude, entities) => ({
        ...pagination,
        ...search,
        ...entities,
        ordering:       sort,
        exclude,
        selected_month: Math.floor(selectedMonth / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'cloudBillingProjects',
        endpoint:           endpoints.cloudBilling.projectsEndpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: item => ({
            ...item,
            total:         item.total_selected_month,
            totalPrevious: item.total_previous_month,
            count:         item.count,
            results:       item.results.map(project => ({
                id:                    project.id,
                name:                  project.name,
                spending:              project.spending_selected_month,
                previousSpending:      project.spending_previous_month,
                spendingSelectedMonth: project.spending_selected_month,
                spendingPreviousMonth: project.spending_previous_month
            }))
        })
    })
};




// WEBPACK FOOTER //
// ./src/modules/store/cloudBillingProjects.js